import { IMemberDatasource } from '../datasources/member_datasource';

interface IConfigurationLink {
  text: string;
  url: string;
}

export interface IExternalMemberConfiguration {
  footer_configs: IConfigurationLink[];
}

export interface IMemberConfigurationDataType {
  header: {
    title: string;
  };
  footer: {
    links: IConfigurationLink[];
  };
  content: {
    title: string;
    byLine: string;
    getStartedButton: {
      title: string;
    };
    valueLink: string;
    valueStatements: string[];
  };
}

export interface IMemberConfiguration {
  read(): IMemberConfigurationDataType;
  write(externalConfiguation: IExternalMemberConfiguration): IMemberConfiguration;
  applyMember(memberDatasource: IMemberDatasource): void;
}

export interface IMemberConfigurationProvider {
  read(): IMemberConfigurationDataType;
  configure(configuration?: IMemberConfigurationDataType): void;
}

class MemberConfigurationService implements IMemberConfiguration {
  read(): IMemberConfigurationDataType {
    return MemberConfiguration._configuration;
  }

  write(externalConfiguation: IExternalMemberConfiguration): IMemberConfiguration {
    MemberConfiguration._configuration.footer.links = externalConfiguation.footer_configs;
    return this;
  }
  applyMember(memberDatasource: IMemberDatasource): void {
    const content: any = MemberConfiguration._configuration.content;
    content.valueStatements = _.map(content.valueStatements, (statement: string): string => {
      return _.template(statement)(memberDatasource);
    });
  }
}

export class MemberConfiguration implements ng.IServiceProvider, IMemberConfigurationProvider {
  public static _configuration: IMemberConfigurationDataType;
  private static DEFAULT: IMemberConfigurationDataType = {
    header: {
      title: ''
    },
    footer: {
      links: []
    },
    content: {
      title: `Simplify your transfer process`,
      byLine: `Transferring can be a confusing process. We're here to help you see whether your credits may transfer and what steps you need to take.`,
      getStartedButton: {
        title: `Get started`
      },
      valueLink: `See how your credits transfer`,
      valueStatements: [
        `See how your credits transfer to your {{ core_config.short_name }} degree.`,
        `Track your transfer steps, deadlines & progress.`,
        `Find resources to ease your transition to {{ core_config.short_name }}.`
      ]
    }
  };

  constructor() {
    this.configure();
  }

  configure(configuration?: IMemberConfigurationDataType): void {
    MemberConfiguration._configuration = _.merge({}, MemberConfiguration.DEFAULT, configuration);
  }

  read(): IMemberConfigurationDataType {
    return MemberConfiguration._configuration;
  }

  $get(): IMemberConfiguration {
    return new MemberConfigurationService();
  }
}

angular.module('capability-ng-global').provider('ngMemberConfiguration', MemberConfiguration);



// WEBPACK FOOTER //
// ./app/lib/global/configuration/member_configuration.ts